import coursesTransformer from './../../transformers/courses';
import store from 'store';
import { makeRequest } from 'utils/requestLogger';

// When the request succeeds
const success = (courses) => {
  // TODO: fetch using a transformer to filter out only the necessary data
  const courselist = coursesTransformer.fetch(courses);
  store.dispatch('setCourses', courselist);
  return;
};

export default (options) => {
  if (options && options.dispatchCourseLoading) {
    store.dispatch('setCourseLoading', true);
  }

  // return makeRequest('get', '/api/courses')
  return makeRequest('get', '/api/courses')
    .then((resp) => {
      success(resp.data);
      store.dispatch('setCourseLoading', false);
      return resp;
    })
    .catch((e) => {
      console.error(e);
      store.dispatch('setCourseLoading', false);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/courses/loadCourses.js